export const PAGE_SECTIONS_KEYS = {
  REVIEWS: "reviews",
  FAQS: "faqs",
  CUSTOM_CERTIFICATE_TITLE: "custom_certificate_title",
  BOOKING_CTA_TEXT: "booking_cta_text",
  INITIATE_BOOKING_CTA_TEXT: "popup_initiate_booking_cta_text",
  BOOKING_TITLE: "booking_popup_header_title",
  TERMS_CONDITIONS: "custom_t_c",
  ABOUT_OFFERINGS: "about_offerings",
  OFFERING_DESC: "event_desc_minify_length",
  HIDE_WORKSHOP: "hide_workshop_schedule",
  MEETING_LOCATION: "meeting_location",
  HIDE_GET_IN_TOUCH: "hide_get_in_touch_section",
  PERSONAL_ADDRESS_TITLE: "personal_address_title",
  HIDE_CREATOR_ADDRESS: "show_creator_personal_address",
  HIDE_TRUST_MARKERS: "hide_trustmarker_icons",
  CREATOR_CONTACT_CTA_TEXT: "contact_creator_cta_text",
  SHARE_CTA_TEXT: "share_event_cta_text",
  MEET_CREATOR_HEADER: "meet_creator",
  CERTIFICATE_TITLE: "custom_certificate_title",
  PHONE_TITLE: "call_section_title",
  PHONE_DECRIPTION_TITLE: "call_section_description",
  VISIT_WEBSITE_CTA: "visit_website_cta",
  TRUST_MARKERS: "trust_markers",
  IS_DIGIO_KYC_ENABLED: "is_digio_kyc_enabled",
  KYC_TYPE: "kyc_type",
  KRA_CONTRACT_URL: "kra_contract_url",
  KYC_WORKFLOW: "kyc_workflow",
  IS_ESIGN_ENABLED: "is_esign_enabled",
  ESIGN_PLACEMENT: "esign_placement",
  KYC_FREQUENCY: "kyc_frequency",
  CONTRACT_PDF_URL: "contract_pdf_url",
  CUSTOM_TNC: "custom_t_c",
  CUSTOM_TNC_LABEL: "custom_t_c_label",
};

export const KYC_TYPE = {
  ESIGN: 1,
  KRA: 2,
};

export const KYC_TYPE_OPTIONS = [
  {
    label: "Enable Aadhaar e-signing of contract",
    value: KYC_TYPE.ESIGN,
  },
  { label: "KYC Registration Agency Workflow", value: KYC_TYPE.KRA },
];

export const KYC_FREQUENCY = {
  INHERIT: 1,
  CUSTOMER_ONCE: 2,
  PER_OFFERING_ONCE: 3,
  EVERY_TXN: 4,
};
